// 个人中心——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `icon/use/index${i + 1}`,
  name: `icon/useIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/use/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 个人中心——主流程，开始
    ...MainRoutes,
  ],
};
